import Base from './base';

class UserGuide extends Base {

  getPath(locale: string, subPath?: string) {
    if (window.location.href.includes('user-guide-v3')) return `user-guide-v3/${this.model}/${locale}/${subPath}`
    return `/${this.model}/${locale}/${subPath}`
  }

  async getSource(subPath?: string) {
    await this.init()
    const fallback = Array.from(new Set([this.fallback, 'en', 'zh_cn']))
      .filter((t) => Boolean(t) && t !== this.locale)
      .map((t) => this.getPath(t, subPath));
    return {
      source: this.getPath(this.locale, subPath),
      fallback,
    };
  }
}

export default new UserGuide();
